import { FormErrorLabel, FormInput, Heading, Loader } from "@/components";
import useAdd from "./useAdd";
import { FormProvider } from "react-hook-form";
import {
  CATEGORY_NAME,
  DESCRIPTION,
  SUB_CATEGORY,
  SUB_CATEGORY_DESC,
  SUB_CATEGORY_NAME,
} from "./consts";
import { Button } from "@/components/ui";
import { Trash2 } from "lucide-react";

const Add = () => {
  const {
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    onCancel,
    onDeleteSubCategory,
    onAddMoreSubCategory,
    isAddSubCategoryPending,
    isView,
    isLoadingCategoryData,
    isLoadingSubcategory,
    isDeleteSubCategoryPending,
    isUpdatePending
  } = useAdd();
  const { errors } = form.formState;

  return (
    <div>
      <Heading
        title={<span className="text-[18px]">{"Add Category"}</span>}
        showBack
        // breadcrumbData={breadcrumbData}
        onBackClick={onBackClick}
      />

      {isLoadingCategoryData || isLoadingSubcategory ? <Loader/> :
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] px-[30px] py-[25px]">
              <FormInput
                name={CATEGORY_NAME}
                control={form.control}
                label="Category Name"
                placeholder="Please enter"
                error={errors[CATEGORY_NAME]?.message}
                isRequired={requiredFields.includes(CATEGORY_NAME)}
                disabled={isView}
              />
              <FormInput
                name={DESCRIPTION}
                control={form.control}
                label="Description"
                placeholder="Please enter"
                error={errors[DESCRIPTION]?.message}
                isRequired={requiredFields.includes(DESCRIPTION)}
                disabled={isView}
              />
            </div>
            <div className="bg-brown-200 mt-[20px] py-[25px] px-[30px] gap-5 grid grid-cols-1">
              {form.watch(SUB_CATEGORY)?.map((_, index: any) => (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px]">
                  <FormInput
                    name={`${SUB_CATEGORY}.${index}.${SUB_CATEGORY_NAME}`}
                    control={form.control}
                    label="Sub Category Name"
                    placeholder="Please enter"
                    error={
                      (errors as any)?.[SUB_CATEGORY]?.[index]?.[SUB_CATEGORY_NAME]?.message ?? ''
                    }
                    isRequired={requiredFields.includes(
                      `${SUB_CATEGORY}.${index}.${SUB_CATEGORY_NAME}`
                    )}
                    disabled={isView}
                  />

                  <div className="flex flex-row gap-5 w-full items-center ">
                    <div className="w-[95%]">
                      <FormInput
                        name={`${SUB_CATEGORY}.${index}.${SUB_CATEGORY_DESC}`}
                        control={form.control}
                        label="Description"
                        placeholder="Please enter"
                        error={
                          (errors as any)?.[SUB_CATEGORY]?.[index]?.[SUB_CATEGORY_DESC]?.message ?? ''
                        }
                        isRequired={requiredFields.includes(
                          `${SUB_CATEGORY}.${index}.${SUB_CATEGORY_DESC}`
                        )}
                        disabled={isView}
                      />
                    </div>
                    <Trash2
                      className="stroke-red-600 w-[10%] cursor-pointer"
                      onClick={onDeleteSubCategory(index)}
                    />
                  </div>
                </div>
              ))}
              <FormErrorLabel className="relative">{errors[SUB_CATEGORY]?.root?.message || ""}</FormErrorLabel>
              {isView ? <></> :<div>
                <Button
                  onClick={onAddMoreSubCategory}
                  type="button"
                  variant="link"
                  className="mt-3"
                >
                  + Add More
                </Button>
              </div>}
            </div>
          </div>

          <div className="flex flex-row justify-end gap-3  py-3">
            <Button
              variant="outline"
              type="button"
              onClick={onCancel}
              disabled={isAddPending || isAddSubCategoryPending || isDeleteSubCategoryPending || isUpdatePending}
            >
              Cancel
            </Button>
            {isView ? <></> : <Button
              type="submit"
              disabled={isAddPending || isAddSubCategoryPending || isDeleteSubCategoryPending || isUpdatePending}
            >
              {isAddPending ||
                isAddSubCategoryPending || isDeleteSubCategoryPending || isUpdatePending && <Loader variant="secondary" />}
              Save
            </Button>}
          </div>
        </form>
      </FormProvider>}
    </div>
  );
};

export default Add;
